import { render, staticRenderFns } from "./OfferGroup.vue?vue&type=template&id=6bdf1881&scoped=true"
import script from "./OfferGroup.vue?vue&type=script&lang=js"
export * from "./OfferGroup.vue?vue&type=script&lang=js"
import style0 from "./OfferGroup.vue?vue&type=style&index=0&id=6bdf1881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf1881",
  null
  
)

export default component.exports